var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReview = function SvgReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M2 4.667V3.333A1.333 1.333 0 0 1 3.333 2h1.334M11.333 2h1.334A1.333 1.333 0 0 1 14 3.333v1.334M14 11.333v1.334A1.334 1.334 0 0 1 12.667 14h-1.334M4.667 14H3.333A1.334 1.334 0 0 1 2 12.667v-1.334"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#review_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.875 7.768v1.158m0-1.158V4.991c0-.384.317-.695.708-.695.392 0 .709.311.709.695M5.875 7.768a.7.7 0 0 0-.708-.694.7.7 0 0 0-.709.694v.926c0 1.918 1.586 3.473 3.542 3.473s3.542-1.555 3.542-3.473V6.38a.7.7 0 0 0-.709-.695.7.7 0 0 0-.708.695M7.292 4.99v2.547m0-2.546v-.463c0-.384.317-.695.708-.695s.708.311.708.695v.463m0 0v2.546m0-2.546c0-.384.317-.695.709-.695.39 0 .708.311.708.695V6.38m0 0v1.157"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "review_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 3h10v10H3z"
  })))));
};
export default SvgReview;